module.exports = __webpack_public_path__ + "static/media/ecelllogo.7153b96e.png";